import DateFnsUtils from "@date-io/date-fns";
import Box from "@material-ui/core/Box";
import { makeStyles, Theme, useTheme, Paper } from "@material-ui/core";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import {
  KeyboardDatePicker,
  KeyboardDateTimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { useAppDispatch, useAppSelector } from "app/hooks";
import InputSearch from "components/InputSearch";
import { ListParams } from "models/common";
import moment from "moment";
import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import clsx from "clsx";
import { locale } from "utils/config";
import PublishIcon from "@material-ui/icons/Publish";
import ScheduleIcon from "@material-ui/icons/Schedule";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import ListLessonDraft from "./components/ListDraft";
import ListLessonFuture from "./components/ListFuture";
import ListLessonPosted from "./components/ListPosted";
import ListVideoHidden from "./components/ListVideoHidden";
import {
  clearFilterLessonListDraft,
  clearFilterLessonListFuture,
  clearFilterLessonListPosted,
  clearFilterLessonListHidden,
  fetchLessonList,
  selectFilterLessonListDraft,
  selectFilterLessonListHidden,
  selectFilterLessonListFuture,
  selectFilterLessonListPosted,
  selectLessonList,
  setFilterSearchDebounceLessonListDraft,
  setFilterSearchDebounceLessonListHidden,
  setFilterSearchDebounceLessonListFuture,
  setFilterSearchDebounceLessonListPosted,
} from "./managerLessonSlice";
import EmptyComponent from "components/Empty";

interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box style={{ padding: 0 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  containerRoot: {
    maxWidth: 1200,
    margin: "0 auto",
    padding: "0 16px",
    boxSizing: "border-box",
    [theme.breakpoints?.down("sm")]: {
      padding: "0 12px",
    },
  },
  root: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  background: {
    background: "linear-gradient(135deg, #0F172A 0%, #1E293B 100%)",
    borderRadius: 20,
    padding: "28px 32px",
    marginBottom: 20,
    position: "relative",
    overflow: "hidden",
    boxShadow: "0 10px 25px -5px rgba(15, 23, 42, 0.25)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 20,
    minHeight: 120,
    boxSizing: "border-box",
    [theme.breakpoints?.down("sm")]: {
      padding: "20px 18px",
      borderRadius: 16,
      minHeight: "auto",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      top: "-40%",
      right: "-10%",
      width: 300,
      height: 300,
      background: "radial-gradient(circle, rgba(99, 102, 241, 0.25) 0%, rgba(99, 102, 241, 0) 70%)",
      pointerEvents: "none",
    },
    "& >h6": {
      color: "#FFFFFF !important",
      fontSize: "1.75rem !important",
      fontWeight: "800 !important",
      margin: "0 !important",
      position: "relative !important",
      left: "auto !important",
      top: "auto !important",
      bottom: "auto !important",
      zIndex: 2,
      [theme.breakpoints?.down("sm")]: {
        fontSize: "1.25rem !important",
      },
    },
  },
  btn_listTest: {
    background: "linear-gradient(360deg, #399BD9 0%, #83CFFF 172.67%)",
    color: "#fff",
    borderRadius: 20,
    "&:hover": {
      backgroundColor: "#E38825",
    },
  },
  stickyTabs: {
    position: "sticky",
    top: 76,
    zIndex: 11,
    padding: "6px 0",
    marginBottom: 20,
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    [theme.breakpoints?.down("sm")]: {
      top: 68,
    },
  },
  tabsCard: {
    backgroundColor: "#FFFFFF",
    borderRadius: 20,
    padding: 8,
    border: "1px solid #E2E8F0",
    boxShadow: "0 4px 20px -4px rgba(15, 23, 42, 0.08)",
  },
  tabsWrapper: {
    backgroundColor: "#F8FAFC",
    borderRadius: 14,
    padding: 4,
    display: "flex",
    border: "1px solid #F1F5F9",
  },
  tabs: {
    width: "100%",
    minHeight: 44,
    "& .MuiTabs-indicator": {
      display: "none",
    },
  },
  tabItem: {
    minHeight: 44,
    borderRadius: 12,
    fontWeight: 700,
    fontSize: "0.875rem",
    color: "#64748B",
    textTransform: "none",
    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
    padding: "8px 20px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    "& .MuiTab-wrapper": {
      flexDirection: "row",
      gap: 8,
    },
    "&:hover": {
      color: "#0F172A",
      backgroundColor: "rgba(255, 255, 255, 0.6)",
    },
    "&.Mui-selected": {
      color: "#FFFFFF !important",
      backgroundColor: "#0F172A !important",
      boxShadow: "0 4px 14px rgba(15, 23, 42, 0.2)",
    },
  },
  backgroundContent: {
    backgroundColor: "transparent",
    padding: 0,
  },
  filterToolbar: {
    display: "flex",
    alignItems: "center",
    gap: 16,
    padding: "16px 20px",
    backgroundColor: "#FFFFFF",
    borderRadius: 20,
    border: "1px solid #E2E8F0",
    boxShadow: "0 4px 20px -4px rgba(15, 23, 42, 0.06)",
    marginBottom: 20,
    position: "sticky",
    top: 144, // below sticky tabs
    zIndex: 10,
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    [theme.breakpoints?.down("sm")]: {
      top: 136,
      flexDirection: "column",
      alignItems: "stretch",
      padding: 16,
      borderRadius: 16,
    },
  },
  datePickerContainer: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    [theme.breakpoints?.down("sm")]: {
      flexDirection: "column",
      width: "100%",
    },
  },
  datePicker: {
    margin: 0,
    width: 175,
    [theme.breakpoints?.down("sm")]: {
      width: "100%",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 12,
      backgroundColor: "#F8FAFC",
      height: 44,
      fontSize: "0.875rem",
      transition: "all 0.2s ease",
      "&:hover": {
        backgroundColor: "#F1F5F9",
      },
      "& fieldset": {
        borderColor: "#E2E8F0",
      },
      "&:hover fieldset": {
        borderColor: "#CBD5E1",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#0F172A",
      },
    },
    "& .MuiOutlinedInput-adornedEnd": {
      paddingRight: 6,
    },
    "& .MuiIconButton-root": {
      padding: 6,
      marginRight: -2,
    },
    "& .MuiOutlinedInput-input": {
      padding: "12px 6px 12px 14px",
      height: "auto",
      boxSizing: "border-box",
    },
    "& .MuiFormLabel-root": {
      fontSize: "0.8125rem",
      fontWeight: 600,
      color: "#64748B",
      top: "50%",
      transform: "translate(14px, -50%) scale(1)",
    },
    "& .MuiFormLabel-root.MuiInputLabel-shrink": {
      top: 0,
      transform: "translate(14px, -6px) scale(0.75)",
    },
  },
  stickyActive: {
    backgroundColor: "#FFFFFF !important",
    boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.08), 0 8px 10px -6px rgba(0, 0, 0, 0.08)",
    borderColor: "#E2E8F0",
  },
}));

const tabNameToIndex: Record<number, string> = {
  0: "listPosted",
  1: "listFuture",
  2: "listDraft",
  3: "listVideoHidden",
};
const indexToTabName: Record<string, number> = {
  listPosted: 0,
  listFuture: 1,
  listDraft: 2,
  listVideoHidden: 3,
};

export default function ManagerListLesson() {
  const classes = useStyles();
  const params = useParams();
  const page = params.page ? params.page : "listPosted";
  const theme = useTheme();
  const [selectedTab, setSelectedTab] = useState(indexToTabName[page]);
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const containerRef = useRef<HTMLDivElement>(null);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const scrollContainer = containerRef.current?.closest("main");
    if (!scrollContainer) return;

    const handleScroll = () => {
      setIsSticky(scrollContainer.scrollTop > 180);
    };

    scrollContainer.addEventListener("scroll", handleScroll, { passive: true });
    return () => scrollContainer.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const targetParents: HTMLElement[] = [];
    const originalOverflows: string[] = [];

    if (containerRef.current) {
      let parent = containerRef.current.parentElement;
      while (parent && parent.tagName !== "MAIN") {
        const computedStyle = window.getComputedStyle(parent);
        if (
          computedStyle.overflow === "hidden" ||
          computedStyle.overflowX === "hidden" ||
          computedStyle.overflowY === "hidden"
        ) {
          targetParents.push(parent);
          originalOverflows.push(parent.style.overflow);
          parent.style.overflow = "visible";
        }
        parent = parent.parentElement;
      }
    }

    return () => {
      targetParents.forEach((parent, index) => {
        if (parent) {
          parent.style.overflow = originalOverflows[index];
        }
      });
    };
  }, []);

  const [selectedFromDateListPosted, setSelectedFromDateListPosted] = useState<Date | null>(null);
  const [selectedToDateListPosted, setSelectedToDateListPosted] = useState<Date | null>(null);

  const [selectedFromDateListFuture, setSelectedFromDateListFuture] = useState<Date | null>(null);
  const [selectedToDateListFuture, setSelectedToDateListFuture] = useState<Date | null>(null);
  const [selectedFromDateListHidden, setSelectedFromDateListHidden] = useState<Date | null>(null);
  const [selectedToDateListHidden, setSelectedToDateListHidden] = useState<Date | null>(null);
  const handleFromDateChangeListPosted = (date: Date | null) => {
    setSelectedFromDateListPosted(date);
    dispatch(
      setFilterSearchDebounceLessonListPosted({
        ...filterListPosted,
        searchFromDate: moment(date).format("YYYY/MM/DD").split("/").join(""),
      })
    );
  };
  const handleToDateChangeListPosted = (date: Date | null) => {
    setSelectedToDateListPosted(date);
    dispatch(
      setFilterSearchDebounceLessonListPosted({
        ...filterListPosted,
        searchToDate: moment(date).format("YYYY/MM/DD").split("/").join(""),
      })
    );
  };
  const handleFromDateChangeListFuture = (date: Date | null) => {
    setSelectedFromDateListFuture(date);

    dispatch(
      setFilterSearchDebounceLessonListFuture({
        ...filterListFuture,
        searchFromDate: moment(date).format("YYYY/MM/DD").split("/").join(""),
      })
    );
  };

  const handleToDateChangeListFuture = (date: Date | null) => {
    setSelectedToDateListFuture(date);
    dispatch(
      setFilterSearchDebounceLessonListFuture({
        ...filterListFuture,
        searchToDate: moment(date).format("YYYY/MM/DD").split("/").join(""),
      })
    );
  };
  const handleFromDateChangeListHidden = (date: Date | null) => {
    setSelectedFromDateListHidden(date);

    dispatch(
      setFilterSearchDebounceLessonListHidden({
        ...filterListHidden,
        searchFromDate: moment(date).format("YYYY/MM/DD").split("/").join(""),
      })
    );
  };

  const handleToDateChangeListHidden = (date: Date | null) => {
    setSelectedToDateListHidden(date);
    dispatch(
      setFilterSearchDebounceLessonListHidden({
        ...filterListHidden,
        searchToDate: moment(date).format("YYYY/MM/DD").split("/").join(""),
      })
    );
  };

  const filterListPosted = useAppSelector(selectFilterLessonListPosted);
  const filterListFuture = useAppSelector(selectFilterLessonListFuture);
  const filterListDraft = useAppSelector(selectFilterLessonListDraft);
  const filterListHidden = useAppSelector(selectFilterLessonListHidden);
  const listLesson = useAppSelector(selectLessonList);
  useEffect(() => {
    document.title = t("managerLesson.danhsachbaihoc").toUpperCase();
    if (selectedTab === 0) {
      dispatch(fetchLessonList(filterListPosted));
      // clear filter
      dispatch(clearFilterLessonListFuture());
      dispatch(clearFilterLessonListDraft());
      dispatch(clearFilterLessonListHidden());
    } else if (selectedTab === 1) {
      dispatch(fetchLessonList(filterListFuture));

      // clear filter
      dispatch(clearFilterLessonListPosted());
      dispatch(clearFilterLessonListDraft());
      dispatch(clearFilterLessonListHidden());
    } else if (selectedTab === 2) {
      dispatch(fetchLessonList(filterListDraft));

      // clear filter
      dispatch(clearFilterLessonListFuture());
      dispatch(clearFilterLessonListHidden());
      dispatch(clearFilterLessonListPosted());
    } else {
      dispatch(fetchLessonList(filterListHidden));
      //clear filter
      dispatch(clearFilterLessonListFuture());
      dispatch(clearFilterLessonListDraft());
      dispatch(clearFilterLessonListPosted());
    }
  }, [
    dispatch,
    filterListPosted,
    filterListFuture,
    filterListDraft,
    filterListHidden,
    selectedTab,
    t,
  ]);
  useEffect(() => {
    setSelectedTab(indexToTabName[page]);
  }, [params, page]);
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    navigate(`/admin/manager-lesson/${tabNameToIndex[newValue]}`);
    setSelectedTab(newValue);
  };
  const handleSearchListPosted = (newFilter: ListParams) => {
    const { name, ...rest } = newFilter;
    dispatch(setFilterSearchDebounceLessonListPosted({ ...rest, searchName: name }));
  };
  const handleSearchListHidden = (newFilter: ListParams) => {
    const { name, ...rest } = newFilter;
    dispatch(setFilterSearchDebounceLessonListHidden({ ...rest, searchName: name }));
  };
  const handleSearchListFuture = (newFilter: ListParams) => {
    const { name, ...rest } = newFilter;
    dispatch(setFilterSearchDebounceLessonListFuture({ ...rest, searchName: name }));
  };
  const handleSearchListDraft = (newFilter: ListParams) => {
    const { name, ...rest } = newFilter;
    dispatch(setFilterSearchDebounceLessonListDraft({ ...rest, searchName: name }));
  };
  return (
    <div ref={containerRef} className={classes.containerRoot}>
      <Box>
        <Box className={classes.stickyTabs}>
          <Paper elevation={0} className={classes.tabsCard}>
            <Box className={classes.tabsWrapper}>
              <Tabs
                value={selectedTab}
                onChange={handleChange}
                variant="fullWidth"
                className={classes.tabs}
              >
                <Tab
                  icon={<PublishIcon style={{ fontSize: 18 }} />}
                  label={t("managerLesson.dadang")}
                  className={classes.tabItem}
                />
                <Tab
                  icon={<ScheduleIcon style={{ fontSize: 18 }} />}
                  label={t("managerLesson.lenlich")}
                  className={classes.tabItem}
                />
                <Tab
                  icon={<EditIcon style={{ fontSize: 18 }} />}
                  label={t("managerLesson.bannhap")}
                  className={classes.tabItem}
                />
                <Tab
                  icon={<VisibilityOffIcon style={{ fontSize: 18 }} />}
                  label={t("managerLesson.videodaan")}
                  className={classes.tabItem}
                />
              </Tabs>
            </Box>
          </Paper>
        </Box>

      <Box>
        {selectedTab === 0 && (
          <Box className={classes.backgroundContent}>
            <TabPanel value={selectedTab} index={0} dir={theme.direction}>
              <Paper elevation={0} className={clsx(classes.filterToolbar, isSticky && classes.stickyActive)}>
                <Box flex={1}>
                  <InputSearch
                    label={t("managerLesson.timtheotenbaihoc")}
                    filter={filterListPosted}
                    onSearchChange={handleSearchListPosted}
                  />
                </Box>
                <Box className={classes.datePickerContainer}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                    <KeyboardDateTimePicker
                      className={classes.datePicker}
                      strictCompareDates={true}
                      views={["year", "month", "date"]}
                      autoOk
                      disableToolbar
                      variant="inline"
                      format="dd/MM/yyyy"
                      id="from-date"
                      label={t("managerLesson.tungay")}
                      value={selectedFromDateListPosted}
                      onChange={handleFromDateChangeListPosted}
                      inputVariant="outlined"
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                    />
                    <KeyboardDatePicker
                      views={["year", "month", "date"]}
                      autoOk
                      strictCompareDates={true}
                      className={classes.datePicker}
                      disableToolbar
                      variant="inline"
                      id="to-date"
                      label={t("managerLesson.denngay")}
                      inputVariant="outlined"
                      format="dd/MM/yyyy"
                      value={selectedToDateListPosted}
                      onChange={handleToDateChangeListPosted}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </Box>
              </Paper>
              <ListLessonPosted />
            </TabPanel>
          </Box>
        )}
        {selectedTab === 1 && (
          <Box className={classes.backgroundContent}>
            <TabPanel value={selectedTab} index={1} dir={theme.direction}>
              <Paper elevation={0} className={clsx(classes.filterToolbar, isSticky && classes.stickyActive)}>
                <Box flex={1}>
                  <InputSearch
                    label={t("managerLesson.timtheotenbaihoc")}
                    filter={filterListFuture}
                    onSearchChange={handleSearchListFuture}
                  />
                </Box>

                <Box className={classes.datePickerContainer}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      disablePast
                      views={["year", "month", "date"]}
                      autoOk
                      className={classes.datePicker}
                      disableToolbar
                      variant="inline"
                      format="dd/MM/yyyy"
                      id="from-date"
                      label={t("managerLesson.tungay")}
                      value={selectedFromDateListFuture}
                      onChange={handleFromDateChangeListFuture}
                      inputVariant="outlined"
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                    />
                    <KeyboardDatePicker
                      disablePast
                      views={["year", "month", "date"]}
                      autoOk
                      className={classes.datePicker}
                      disableToolbar
                      variant="inline"
                      id="to-date"
                      label={t("managerLesson.denngay")}
                      inputVariant="outlined"
                      format="dd/MM/yyyy"
                      value={selectedToDateListFuture}
                      onChange={handleToDateChangeListFuture}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </Box>
              </Paper>
              {listLesson?.content?.length > 0 ? (
                <ListLessonFuture />
              ) : (
                <Box p={2}>
                  <EmptyComponent isBorder={false} />
                </Box>
              )}
            </TabPanel>
          </Box>
        )}
        {selectedTab === 2 && (
          <Box className={classes.backgroundContent}>
            <TabPanel value={selectedTab} index={2} dir={theme.direction}>
              <Paper elevation={0} className={clsx(classes.filterToolbar, isSticky && classes.stickyActive)}>
                <Box flex={1}>
                  <InputSearch
                    label={t("managerLesson.timtheotenbaihoc")}
                    filter={filterListFuture}
                    onSearchChange={handleSearchListDraft}
                  />
                </Box>
              </Paper>
              {listLesson?.content?.length > 0 ? (
                <ListLessonDraft />
              ) : (
                <Box p={2}>
                  <EmptyComponent isBorder={false} />
                </Box>
              )}
            </TabPanel>
          </Box>
        )}
        {selectedTab === 3 && (
          <Box className={classes.backgroundContent}>
            <TabPanel value={selectedTab} index={3} dir={theme.direction}>
              <Paper elevation={0} className={clsx(classes.filterToolbar, isSticky && classes.stickyActive)}>
                <Box flex={1}>
                  <InputSearch
                    label={t("managerLesson.timtheotenbaihoc")}
                    filter={filterListHidden}
                    onSearchChange={handleSearchListHidden}
                  />
                </Box>
                <Box className={classes.datePickerContainer}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                    <KeyboardDateTimePicker
                      className={classes.datePicker}
                      strictCompareDates={true}
                      views={["year", "month", "date"]}
                      autoOk
                      disableToolbar
                      variant="inline"
                      format="dd/MM/yyyy"
                      id="from-date"
                      label={t("managerLesson.tungay")}
                      value={selectedFromDateListHidden}
                      onChange={handleFromDateChangeListHidden}
                      inputVariant="outlined"
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                    />
                    <KeyboardDatePicker
                      views={["year", "month", "date"]}
                      autoOk
                      strictCompareDates={true}
                      className={classes.datePicker}
                      disableToolbar
                      variant="inline"
                      id="to-date"
                      label={t("managerLesson.denngay")}
                      inputVariant="outlined"
                      format="dd/MM/yyyy"
                      value={selectedToDateListHidden}
                      onChange={handleToDateChangeListHidden}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </Box>
              </Paper>
              <ListVideoHidden />
            </TabPanel>
          </Box>
        )}
      </Box>
      </Box>
    </div>
  );
}
